import styled from "styled-components";
import { ColorOptions } from "@/src/types";
import { MainInner, StyledMainSection } from "@/styles/global";
import {
  DisplayHeadingLCss,
  DisplayHeadingMCss,
  TypographyProps,
} from "@/styles/typography";

type WrapperProps = {
  $backgroundColor?: ColorOptions;
  $backgroundType?: "card" | "fill";
};

type MainProps = {
  $backgroundColor?: ColorOptions;
  $backgroundType?: "card" | "fill";
  $textColor?: ColorOptions;
};

type ColumnProps = {
  $numberOfColumns: number;
  $includesMedia: boolean;
};

const Section = styled(StyledMainSection)`
  &::before {
    content: "";
    display: block;
    height: 100px;
    margin-top: -100px;
    visibility: hidden;
    z-index: -1;
  }
`;

const Inner = styled(MainInner)``;

const Wrapper = styled.div<WrapperProps>`
  width: 100%;
  background-color: ${({ theme, $backgroundColor, $backgroundType }) =>
    $backgroundType === "card"
      ? "transparent"
      : $backgroundColor
        ? theme.colors[$backgroundColor]
        : "transparent"};
`;

const Main = styled(MainInner)<MainProps>`
  background-color: ${({ theme, $backgroundColor }) =>
    $backgroundColor ? theme.colors[$backgroundColor] : "transparent"};
  border-radius: 21px;
  padding: ${({ $backgroundColor, $backgroundType }) =>
    $backgroundColor == "transparent"
      ? "20px 0"
      : $backgroundType === "fill"
        ? "20px 0"
        : "20px 24px"};

  li {
    color: ${({ theme, $textColor }) =>
      $textColor ? theme.colors[$textColor] : "black"};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.xl}) {
    padding: ${({ $backgroundColor, $backgroundType }) =>
      $backgroundColor == "transparent"
        ? "40px 0"
        : $backgroundType === "fill"
          ? "40px 0"
          : "40px 48px"};
  }
`;

const TitleLarge = styled.h2<TypographyProps>`
  ${DisplayHeadingLCss}
  font-size: clamp(40px, 3.5vw, 80px) !important;
`;

const ColumnContainer = styled.div<ColumnProps>`
  display: flex;
  flex-direction: column;
  gap: 32px;
  height: auto;

  //if numberOfColumns is 3
  ${({ $numberOfColumns, theme }) =>
    $numberOfColumns === 3 &&
    `
    @media (min-width: ${theme.breakpoints.xl}) {
      display: grid;
      grid-template-columns: repeat(3, 1fr);
      gap: 72px;
    }
  `}

  //if numberOfColumns is 2
  ${({ $numberOfColumns, $includesMedia, theme }) =>
    $numberOfColumns === 2 &&
    `
    @media (min-width: ${theme.breakpoints.lg}) {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 72px;
      align-items: ${$includesMedia ? "center" : "initial"};
    }
  `}
`;

const S = {
  Section,
  Inner,
  Wrapper,
  Main,
  TitleLarge,
  ColumnContainer,
};

export default S;
